import { fromEvent, startWith, map, distinctUntilChanged, switchMap } from 'rxjs';

import { handleErrors } from './errors.js';
import { createPromptView } from './prompt-view.js';
import { createMyJobsView } from './my-jobs-view.js';
import { createCraftView } from './craft-view.js';

let routePath$ = fromEvent(window, 'hashchange').pipe(
    startWith(undefined),
    map(() => {
        let hash = window.location.hash || '';
        if (hash.startsWith('#')) {
            hash = hash.substring(1);
        }
        return hash.trim();
    }),
    distinctUntilChanged(),
);

let view$ = routePath$.pipe(
    map(path => {
        if (path === '') {
            return createPromptView();
        } else if (path === 'my-jobs') {
            return createMyJobsView();
        } else if (path.startsWith('fork/')) {
            let jobId = path.substring('fork/'.length);
            return createPromptView(jobId);
        } else if (path === 'craft') {
            return createCraftView();
        } else {
            console.warn(`Unknown route: ${path}`);
            return createPromptView();
        }
    }),
);

view$.pipe(
    switchMap(view$ => view$),
    handleErrors(),
).subscribe();
